import { wrapper } from 'src/redux/store'
import { getCoinData, getRemoteMapData } from 'src/redux/thunks'
import { ENTITY } from 'src/consts'
import Widgets from 'src/pages/about/Widgets'

const WidgetsPage = () => <Widgets />

export const getServerSideProps = wrapper.getServerSideProps(
  store => async () => {
    await store.dispatch(
      getCoinData({
        url: process.env.NEXT_PUBLIC_API_ENDPOINT,
        slug: 'bitcoin-btc',
      })
    )
    await store.dispatch(
      getRemoteMapData({
        entity: ENTITY.COIN,
        url: process.env.NEXT_PUBLIC_API_ENDPOINT,
      })
    )
  }
)

export default WidgetsPage
